var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex flex-col xl:flex-row mb-2 sm:mb-0 gap-6 w-full" },
    [
      _vm.contractorUser
        ? _c("PageHeadContainer", {
            staticClass: "profileCard",
            attrs: { title: _vm.contractorFullName },
            scopedSlots: _vm._u(
              [
                {
                  key: "chip",
                  fn: function () {
                    return [_vm._t("chip")]
                  },
                  proxy: true,
                },
                {
                  key: "avatar",
                  fn: function () {
                    return [
                      _c("PageHeadAvatar", {
                        attrs: {
                          avatar: _vm.contractorUser.avatar,
                          user: _vm.contractorUser,
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "role",
                  fn: function () {
                    return [_vm._t("userInfo")]
                  },
                  proxy: true,
                },
                {
                  key: "status",
                  fn: function () {
                    return [_vm._t("optionalInfo")]
                  },
                  proxy: true,
                },
                {
                  key: "icons",
                  fn: function () {
                    return [_vm._t("icons")]
                  },
                  proxy: true,
                },
                {
                  key: "actions",
                  fn: function () {
                    return [_vm._t("actions")]
                  },
                  proxy: true,
                },
                {
                  key: "annotation",
                  fn: function () {
                    return [_vm._t("moreDetails")]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          })
        : _vm._e(),
      _vm._t("document"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }